const normalizeUrl = url => url && url.replace(/^https?:\/\//, '');
const normalizeUrlWWW = url => url && url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').replace(/\/$/, '');
const withProtocol = url => {
  if (url && !url.toLowerCase().match(/^https?:\/\//)) {
    return `https://${url}`;
  }
  return url;
};
const baseUrl = url => {
  try {
    const parsedUrl = new URL(withProtocol(url));
    return `${parsedUrl.protocol}//${parsedUrl.host}`;
  } catch (e) {
    return url;
  }
};

const path = (url) => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.pathname;
  } catch (e) {
    return url;
  }
};

module.exports = {
  normalizeUrl,
  normalizeUrlWWW,
  withProtocol,
  baseUrl,
  path,
};
